"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var BillingApiPaymentResponseDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiPaymentResponseDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_core_payment_status_enum_1 = require("../../../../billing-core/billing-core-payment/types/enums/billing-core-payment-status.enum");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const class_transformer_1 = require("class-transformer");
const types_1 = require("../../../billing-api-account/types");
let BillingApiPaymentResponseDto = BillingApiPaymentResponseDto_1 = class BillingApiPaymentResponseDto {
  constructor() {
    this.__type = BillingApiPaymentResponseDto_1.name;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id начисления",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiPaymentResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления",
  format: "date-time"
}), (0, class_transformer_1.Expose)(), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), __metadata("design:type", Date)], BillingApiPaymentResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Сумма платежа`,
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "100.00"
}), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiPaymentResponseDto.prototype, "amount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта списания",
  format: "^[A-Z]{3}$",
  example: "USD",
  readOnly: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", String)], BillingApiPaymentResponseDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Сумма в валюте зачисления`,
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "2.00",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "balanceAmount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта зачисления",
  format: "^[A-Z]{3}$",
  example: "USD",
  readOnly: true,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "balanceCurrencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Сумма в валюте зачисления`,
  type: String,
  format: "decimal",
  pattern: "^d{1,}(.d{1,6})?$",
  example: "0.57",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "processingFee", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id плательщика",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentResponseDto.prototype, "customerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id транзитного счёта получателя",
  format: "uuid"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentResponseDto.prototype, "receiveAccountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id платёжного аккаунта",
  format: "uuid",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "paymentAccountId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id транзакции",
  format: "uuid",
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "transactionId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Статус платежа`,
  enum: billing_core_payment_status_enum_1.BillingCorePaymentStatusEnum
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsEnum)(billing_core_payment_status_enum_1.BillingCorePaymentStatusEnum), __metadata("design:type", String)], BillingApiPaymentResponseDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `URL перехода к оплате`,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "paymentUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Плательщик",
  type: () => types_1.BillingApiAccountResponseDto,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => types_1.BillingApiAccountResponseDto), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "customer", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Транзитный счёт получателя",
  type: () => types_1.BillingApiAccountResponseDto,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => types_1.BillingApiAccountResponseDto), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "receiveAccount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Платёжный аккаунт",
  type: () => types_1.BillingApiAccountResponseDto,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => types_1.BillingApiAccountResponseDto), __metadata("design:type", Object)], BillingApiPaymentResponseDto.prototype, "paymentAccount", void 0);
BillingApiPaymentResponseDto = BillingApiPaymentResponseDto_1 = __decorate([(0, class_transformer_1.Exclude)()], BillingApiPaymentResponseDto);
exports.BillingApiPaymentResponseDto = BillingApiPaymentResponseDto;
